import { useState } from "react";
import './Login.scss';

export interface AgreementData {
  checkUsingPolicy: boolean;
  checkPersonalInfo: boolean;
  checkContentsRestrict: boolean;
  checkInfoToOthers: boolean;
  checkServiceNotifi: boolean;
}

interface Props {
  onNext: (data: AgreementData) => void;
}

export default function LogisterAgree({ onNext }: Props) {
  const [checkAll, setCheckAll] = useState(false);
  const [checkUsingPolicy, setCheckUsingPolicy] = useState(false);
  const [checkPersonalInfo, setCheckPersonalInfo] = useState(false);
  const [checkContentsRestrict, setCheckContentsRestrict] = useState(false);
  const [checkInfoToOthers, setCheckInfoToOthers] = useState(false);
  const [checkServiceNotifi, setCheckServiceNotifi] = useState(false);

  const handleCheckAll = () => {
    const next = !checkAll;
    setCheckAll(next);
    setCheckUsingPolicy(next);
    setCheckPersonalInfo(next);
    setCheckContentsRestrict(next);
    setCheckInfoToOthers(next);
    setCheckServiceNotifi(next);
  };

  const isRequiredAgreed = checkUsingPolicy && checkPersonalInfo && checkContentsRestrict && checkInfoToOthers;

  return (
    <>
      <div className="lp__auth-card">
        <div className="lp__auth-title-row">
          <div>
            <h2 className="lp__auth-title">회원가입</h2>
            <p className="lp__auth-subtitle">서비스 약관에 동의해주세요.</p>
          </div>
        </div>

        <div className="lp__agree-box">
          <label className="lp__agree-all">
            <input type="checkbox" checked={checkAll} onChange={handleCheckAll} />
            <strong>모든 약관에 동의합니다.</strong>
          </label>

          <div className="lp__check-list">
            <div className="lp__check-item">
              <div className="lp__check-main" onClick={() => setCheckUsingPolicy(!checkUsingPolicy)}>
                <input type="checkbox" checked={checkUsingPolicy} onChange={() => {}} />
                <div className="lp__check-copy">
                  <strong>[필수] 서비스 이용약관 동의</strong>
                  <span>회원가입 및 서비스 이용을 위한 기본 약관입니다.</span>
                </div>
              </div>
              <a className="lp__terms-link" href="http://www.ministermore.co.kr/usingpolicy.html" target="_blank" rel="noreferrer">약관보기</a>
            </div>
            <div className="lp__check-item">
              <div className="lp__check-main" onClick={() => setCheckPersonalInfo(!checkPersonalInfo)}>
                <input type="checkbox" checked={checkPersonalInfo} onChange={() => {}} />
                <div className="lp__check-copy">
                  <strong>[필수] 개인정보 수집·이용 동의</strong>
                  <span>회원 관리 및 문의 대응을 위해 필요한 최소 정보만 수집합니다.</span>
                </div>
              </div>
              <a className="lp__terms-link" href="http://www.ministermore.co.kr/personalinfo.html" target="_blank" rel="noreferrer">약관보기</a>
            </div>
            <div className="lp__check-item">
              <div className="lp__check-main" onClick={() => setCheckContentsRestrict(!checkContentsRestrict)}>
                <input type="checkbox" checked={checkContentsRestrict} onChange={() => {}} />
                <div className="lp__check-copy">
                  <strong>[필수] 유해 컨텐츠에 대한 제재 동의</strong>
                </div>
              </div>
            </div>
            <div className="lp__check-item">
              <div className="lp__check-main" onClick={() => setCheckInfoToOthers(!checkInfoToOthers)}>
                <input type="checkbox" checked={checkInfoToOthers} onChange={() => {}} />
                <div className="lp__check-copy">
                  <strong>[필수] 제3자 정보 제공 동의</strong>
                </div>
              </div>
            </div>
            <div className="lp__check-item">
              <div className="lp__check-main" onClick={() => setCheckServiceNotifi(!checkServiceNotifi)}>
                <input type="checkbox" checked={checkServiceNotifi} onChange={() => {}} />
                <div className="lp__check-copy">
                  <strong>[선택] 혜택성 정보수신 동의</strong>
                  <span>신규 공고, 수련회 장소, 예배사역 소식을 받아보실 수 있습니다.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="lp__action-row">
        <button
          className="lp__btn lp__btn--primary"
          disabled={!isRequiredAgreed}
          onClick={() => {
            if (isRequiredAgreed) {
              onNext({ checkUsingPolicy, checkPersonalInfo, checkContentsRestrict, checkInfoToOthers, checkServiceNotifi });
            } else {
              alert('필수 항목을 모두 체크해주세요.');
            }
          }}
        >
          다음
        </button>
      </div>
    </>
  );
}
